import type { IconSvgObject } from './types';

const HighlighterIcon: IconSvgObject = [
  ["path", { d: "M13.7353 3.5L8.79412 8.44118L16.5588 16.2059L21.5 11.2647M6.67647 16.2059L8.79412 18.3235L6.5 20.5H2.5L6.67647 16.2059ZM5.97059 15.5L9.5 19.0294C11.9706 16.5588 14.0882 17.2647 14.0882 17.2647L15.8529 15.5L9.5 9.14706L7.73529 10.9118C7.73529 10.9118 8.44118 13.0294 5.97059 15.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default HighlighterIcon;
